module.exports = __webpack_public_path__ + "img/appltCourse-img9.8fae3274.png";